import { getProtocolUrl } from 'features/stepByStepProtocol/protocols/config';

export const PROTOCOL_READ_TIMEOUT_MS = 10000;

export const S3_READ_FAILURE = Object.freeze({
    NO_BASE_URL: 'no_base_url',
    TIMEOUT: 'timeout',
    NETWORK: 'network',
});

/**
 * Reads a protocol XML from the environment's S3 bucket with a plain `fetch`: no cookies and none of
 * the `axiosAiq` interceptors. The bucket answers only our IPs and the AIQ origin (CORS); a missing
 * object is a 403 there because listing is denied. The browser cache honours the object's
 * `Cache-Control: max-age=300`. Only `Last-Modified` is readable: the bucket's CORS exposes no ETag or
 * version id.
 */
export async function readProtocolFromS3(source) {
    const meta = { source: 's3', objectKey: source?.objectKey ?? null, lastModified: null };
    const url = getProtocolUrl(source);
    if (!url) return { ok: false, reason: S3_READ_FAILURE.NO_BASE_URL, meta };

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), PROTOCOL_READ_TIMEOUT_MS);
    try {
        const response = await fetch(url, { method: 'GET', credentials: 'omit', signal: controller.signal });
        meta.lastModified = response.headers.get('Last-Modified');
        if (!response.ok) return { ok: false, reason: `http_${response.status}`, meta };
        return { ok: true, text: await response.text(), meta };
    } catch (err) {
        return { ok: false, reason: err?.name === 'AbortError' ? S3_READ_FAILURE.TIMEOUT : S3_READ_FAILURE.NETWORK, meta };
    } finally {
        clearTimeout(timeoutId);
    }
}
